// extracted by mini-css-extract-plugin
module.exports = {"priceUp":"PercentageChangeBlock_priceUp__UixlY","priceDown":"PercentageChangeBlock_priceDown__gY3rQ","trendingIcon":"PercentageChangeBlock_trendingIcon__y6EjB"};